import withStore, {
  TPresentable,
  TLoadingAwarePresenter
} from "../../core/presenter/withStore";
import Application from "../../Application";
import { ILegalView } from "../model/LegalView";
import { IOrganisation } from "../../organisations/model/Organisation";
import { IUser } from "../../user/model/User";
import LegalViewPresentationModel, {
  TLegalViewPresentationModel
} from "./model/LegalViewPresentationModel";
import { IDocumentType } from "../../documentTypes/model/DocumentType";

export interface TLegalViewsPresenter extends TLoadingAwarePresenter {
  legalViews: TLegalViewPresentationModel[];
  organisations: IOrganisation[];
  legalViewTypes: IDocumentType[];
  user?: IUser;
}

export interface ILegalViewsPresenter
  extends TLegalViewsPresenter,
    TPresentable {
  loadAllLegalViews(legalViews: ILegalView[]): void;
  loadReferenceValues(
    legalViewTypes: IDocumentType[],
    organisations: IOrganisation[]
  ): void;
  createNewLegalView(): void;
  showLegalViewDetails(id: number): void;
}

const defaultState: TLegalViewsPresenter = {
  legalViews: [],
  organisations: [],
  legalViewTypes: []
};

const LegalViewsPresenter = withStore<
  ILegalViewsPresenter,
  TLegalViewsPresenter
>(({ application, store, loader, translate }): ILegalViewsPresenter => {
  const _store = store;
  const _application: Application = application;
  const state = _store.getState<
    TLegalViewsPresenter & TLoadingAwarePresenter
  >();

  const loadReferenceValues = (
    legalViewTypes: IDocumentType[],
    organisations: IOrganisation[]
  ) => {
    const user = _store.getState<any>().user;

    _store.update({ legalViewTypes, organisations, user });
  };
  loader.start("legalViewLoader");
  const loadAllLegalViews = (legalViews: ILegalView[]) => {
    const { organisations, legalViewTypes } =
      _store.getState<TLegalViewsPresenter>();
    let legalViewList = (legalViews || []).map((item) => {
      const legalViewType = legalViewTypes?.find(
        (value) => value.id === item.documentTypeId
      );
      const organisation = organisations?.find(
        (value) => value.id === item.organisationId
      );
      const selectedLanguage = _store.getState<any>().selectedLanguage;
      const summary = item.summaryTranslations.find(
        (item) => item.languageId === selectedLanguage.id
      )?.summaryTranslation;
      return LegalViewPresentationModel(
        item,
        legalViewType,
        organisation,
        summary
      );
    });
    const user = _store.getState<any>().user;
    _store.update({
      legalViews: legalViewList,
      user
    });
    loader.stop("legalViewLoader");
  };

  const createNewLegalView = () => {
    return _application.navigator.push({
      pathname: `/legal-views/new`
    });
  };

  const showLegalViewDetails = (id: number) => {
    return _application.navigator.push({
      pathname: `/legal-views/${id.toString()}/details`
    });
  };

  return {
    ...state,
    store: _store,
    loader,
    application: _application,
    translate,
    loadAllLegalViews,
    loadReferenceValues,
    createNewLegalView,
    showLegalViewDetails
  };
}, defaultState);

export default LegalViewsPresenter;
